import React from 'react'
import Select from 'react-select';
import {
  presenceErrorClass,
} from 'servos/formValidations'

class SelectBox extends React.Component {
  render() {
    const {
      errorMessage,
      onChange,
      label,
      selectedOption,
      options,
      className,
    } = this.props

      // <div className="row mt-2">
      // 'col-12'
    return (
      <div className={ className }>
        <label>
          <span>{label}</span>
        </label>
        <Select
          value={selectedOption}
          onChange={onChange}
          options={options}
          className={`form-control-select2 ${presenceErrorClass(errorMessage)}`}
          placeholder={ 'Select' }
        />
        <div className="invalid-feedback">
          { errorMessage }
        </div>
      </div>
    )
  }
}

export default SelectBox;
